/* eslint-disable import/extensions */
import { createApp } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { fas, faLock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { fab, faFacebook, faGooglePlus } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import moment from 'moment';
import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';
import Dialog from 'primevue/dialog';
import Menubar from 'primevue/menubar';
import OrganizationChart from 'primevue/organizationchart';
import InputSwitch from 'primevue/inputswitch';
import Toolbar from 'primevue/toolbar';
import Panel from 'primevue/panel';
import Tag from 'primevue/tag';
import InputMask from 'primevue/inputmask';
import SelectButton from 'primevue/selectbutton';
import InputNumber from 'primevue/inputnumber';
import RadioButton from 'primevue/radiobutton';
import ToggleButton from 'primevue/togglebutton';
import Checkbox from 'primevue/checkbox';
import MultiSelect from 'primevue/multiselect';
import Textarea from 'primevue/textarea';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import draggable from 'vuedraggable'; // Updated import
import TriStateCheckbox from 'primevue/tristatecheckbox';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';

// Import AdminLTE scripts
import '../node_modules/admin-lte/dist/js/adminlte.min.js';
import '../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js';
import '../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js';
import '../node_modules/admin-lte/plugins/daterangepicker/daterangepicker.js';
import '../node_modules/admin-lte/plugins/jquery-knob/jquery.knob.min.js';
import '../node_modules/admin-lte/plugins/sparklines/sparkline.js';
import '../node_modules/admin-lte/plugins/jquery/jquery.min.js';
import '../node_modules/admin-lte/plugins/jquery-ui/jquery-ui.min.js';
import '../node_modules/admin-lte/plugins/inputmask/jquery.inputmask.min.js';
import '../node_modules/admin-lte/plugins/bootstrap-switch/js/bootstrap-switch.min.js';
import '../node_modules/admin-lte/plugins/bs-stepper/js/bs-stepper.min.js';
import '../node_modules/admin-lte/plugins/dropzone/min/dropzone.min.js';

// Import AdminLTE styles
import '../node_modules/admin-lte/dist/css/adminlte.min.css';
import '../node_modules/admin-lte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css';
import '../node_modules/admin-lte/plugins/summernote/summernote-bs4.min.css';
import '../node_modules/admin-lte/plugins/daterangepicker/daterangepicker.css';
import '../node_modules/admin-lte/plugins/jqvmap/jqvmap.min.css';
import '../node_modules/admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css';
import '../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css';
import '../node_modules/admin-lte/plugins/bootstrap4-duallistbox/bootstrap-duallistbox.min.css';
import '../node_modules/admin-lte/plugins/bs-stepper/css/bs-stepper.min.css';
import '../node_modules/admin-lte/plugins/dropzone/min/dropzone.min.css';

// Import PrimeVue styles
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

// Initialize AOS
AOS.init({
  disable: 'phone',
  offset: 120,
  easing: 'ease',
  duration: 600,
});

window.jQuery = require('jquery');

window.$ = window.jQuery;

library.add(fas, fab, far, faLock, faEnvelope, faFacebook, faGooglePlus);
dom.watch();

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      console.log('validated');
      const location = window.location.pathname;
      if (!location.includes('/auth/password/reset/confirm/')) {
        store.dispatch('users/setUnauthenticated');
        router.push('/login/');
      }
    }
    return Promise.reject(error);
  },
);

const app = createApp(App);

// Make moment globally available
app.config.globalProperties.$moment = moment;

app
  .use(store)
  .use(router) // Removed duplicate router
  .use(PrimeVue)
  .use(ToastService)
  .component('VueDraggable', draggable) // Register as component
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('DataTable', DataTable)
  .component('InputSwitch', InputSwitch)
  .component('ToggleButton', ToggleButton)
  .component('SelectButton', SelectButton)
  .component('Toast', Toast)
  .component('RadioButton', RadioButton)
  .component('TriStateCheckbox', TriStateCheckbox)
  .component('Checkbox', Checkbox)
  .component('Column', Column)
  .component('InputText', InputText)
  .component('Dropdown', Dropdown)
  .component('Menubar', Menubar)
  .component('OrganizationChart', OrganizationChart)
  .component('Dialog', Dialog)
  .component('Button', Button)
  .component('Toolbar', Toolbar)
  .component('Panel', Panel)
  .component('Tag', Tag)
  .component('InputMask', InputMask)
  .component('InputNumber', InputNumber)
  .component('Textarea', Textarea)
  .component('MultiSelect', MultiSelect)
  .component('VueNumberInput', VueNumberInput)
  .directive('tooltip', Tooltip)
  .mount('#app');
